import React from 'react';
import { Stack } from '@mui/material';
import { LegalItem, LegalPage, LegalSection, LegalText } from '@src/components/LegalPage';

const Terms: React.FC = () => (
    <LegalPage
        title="Términos y Condiciones"
        intro="Esto aplica cuando recibes tu recibo por WhatsApp y cuando participas en el programa de Pesos Kabandú."
    >
        <LegalSection title="Recepción de recibos por WhatsApp">
            <LegalText>
                Al proporcionar tu número de teléfono celular y aceptar el envío de tu recibo por WhatsApp, aceptas los
                siguientes términos:
            </LegalText>
            <Stack spacing={1.5} sx={{ pt: 0.5 }}>
                <LegalItem title="1. Consentimiento expreso">
                    Aceptas de manera voluntaria y expresa que el recibo correspondiente a tu compra o servicio te sea
                    enviado a través de la aplicación WhatsApp.
                </LegalItem>
                <LegalItem title="2. Número correcto">
                    Es tu responsabilidad proporcionar un número de WhatsApp correcto y activo. Kabandú no se hace
                    responsable por entregas erróneas causadas por números incorrectos.
                </LegalItem>
                <LegalItem title="3. Uso del número">
                    El número proporcionado será utilizado para el envío del recibo o información relacionada con la
                    transacción realizada.
                </LegalItem>
                <LegalItem title="4. No spam">
                    No se utilizará tu número para promociones, mensajes masivos o fines distintos a los aquí
                    mencionados.
                </LegalItem>
                <LegalItem title="5. Medio alternativo">
                    Si deseas recibir tu recibo por otro medio (correo electrónico o físico), puedes solicitarlo en
                    cualquier momento.
                </LegalItem>
            </Stack>
        </LegalSection>

        <LegalSection title="Programa de Pesos Kabandú">
            <Stack spacing={1.5}>
                <LegalItem title="1. Acumulación">
                    Por cada servicio recibido en Kabandú acumulas Pesos Kabandú según el valor de tu compra.
                </LegalItem>
                <LegalItem title="2. Canje">
                    Los Pesos Kabandú pueden canjearse por servicios o productos según el catálogo vigente.
                </LegalItem>
                <LegalItem title="3. Servicios de un paquete">
                    Si tu paquete incluye varios servicios y no los realizas todos en la misma visita, los que queden
                    pendientes NO vencen: quedan registrados a tu nombre y puedes completarlos cuando gustes.
                </LegalItem>
            </Stack>
        </LegalSection>
    </LegalPage>
);

export default Terms;
